import { clsx } from 'clsx'
import type { ButtonProps } from '@/types'
import styles from './Button.module.css'

export function Button({
  children,
  type = 'button',
  variant = 'primary',
  size = 'md',
  icon,
  iconPosition = 'left',
  loading = false,
  disabled = false,
  fullWidth = false,
  onClick,
  className
}: ButtonProps) {
  const buttonClasses = clsx(
    styles.button,
    styles[variant],
    styles[size],
    {
      [styles.fullWidth]: fullWidth,
      [styles.loading]: loading,
      [styles.hasIcon]: icon,
      [styles.iconRight]: iconPosition === 'right'
    },
    className
  )

  return (
    <button
      type={type}
      className={buttonClasses}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {loading && (
        <span className={styles.spinner}>
          <i className="bi bi-arrow-repeat" />
        </span>
      )}
      
      {icon && iconPosition === 'left' && !loading && (
        <i className={`bi bi-${icon} ${styles.icon}`} />
      )}
      
      <span className={styles.label}>{children}</span>
      
      {icon && iconPosition === 'right' && !loading && (
        <i className={`bi bi-${icon} ${styles.icon}`} />
      )}
    </button>
  )
}







